import { JsonFetch } from "@roc-digital/mxm-base/logic";
import { ViewSchema } from "@roc-digital/mxm-base/data";

export async function readView(id: string) {
  const view = await JsonFetch<ViewSchema>({
    method: 'GET',
    url: `${process.env.REACT_APP_AUX_API_URL}/admin/views/${id}`,
  });

  if(view.zones?.length) {
    for(let zone of view.zones) {
      if(!zone.count) continue;

      if(zone.articleIds?.length && zone.articleIds?.length > zone.count) {
        zone.articleIds = zone.articleIds.splice(zone.count, zone.articleIds.length - zone.count);
      }

      if(zone.articlePlaces?.length && zone.articlePlaces?.length > zone.count) {
        zone.articlePlaces = zone.articlePlaces.splice(zone.count, zone.articlePlaces.length - zone.count);
      }

      if(zone.articles?.length && zone.articles?.length > zone.count) {
        zone.articles = zone.articles.splice(zone.count, zone.articles.length - zone.count);
      }
    }
  }

  return view;
}
